<template>
  <div class="template-selector-fills">
    <h4>Tareas</h4>
    <div class="selector">
      <TemplateSelector :selectedId="templateSelected" :pageSize="50" @select="selectTemplate" placeholder="Seleccione un formulario"/>
    </div>

    <div class="templates-history shadow-sm">
      <div class="item title">Utilizados recientemente</div>
      <div class="item" v-for="template in historyTemplates" :key="template.id" @click="selectTemplate(template)"
        :class="{ 'inactive': Template.isInactive(template) }"
      >
        <i class="fal fa-clock"></i><span>{{ template.label }} [v{{template.version}}]</span>
      </div>
    </div>

    <div class="init-bg">
      <img  src="@/assets/img/bm-main-fillgrid.jpg">
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import TemplateSelector from '@/components/generic/TemplateSelector.vue'
import { Template } from '@/types/Templates'
import templatesService from '@/services/TemplatesService'

@Component({
  components: {
    TemplateSelector
  }
})
export default class FillgridTemplate extends Vue {
  Template = Template
  historyTemplates: Template[] = templatesService.getLatestSelectedTemplatesForTracking()

  templateSelected: string = ''

  selectTemplate (template: Template) {
    this.$router.push({ name: 'fillgridData', params: { id: template.id.toString() } })
    templatesService.addItemToLatestSelectedTemplatesForTracking(template)
  }
}
</script>

<style lang="scss">
.template-selector-fills {
  width: 100%;
  height: 100%;
  padding: 3% 20px;

  $selector-width: 400px;

  .selector {
    position: relative;
    width: $selector-width;
    margin: 0 auto;
    margin-bottom: 10px;
  }

  h4 {
    font-size: 1.2rem;
    color: #afafaf;
    margin-bottom: 18px;
    text-align: center;
  }

  .templates-history {
    width: $selector-width;
    padding-top: 5px;
    margin: 0 auto;
    background-color: #fff;
    margin-bottom: 30px;
    .item {
      padding: 10px 15px;
      font-size: 0.85rem;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #616161;
      &.inactive {
        color: #c0c0c0;
      }
      i {
        margin-right: 8px;
        font-size: 1rem;
        color: #a3a3a3;
      }
      &:hover {
        background-color: var(--element-hover-bg-color);
      }
      &.title {
        color: #a3a3a3;
      }
    }
  }

  .init-bg {
    max-width: 700px;
    margin: 0 auto;
    opacity: 0.4;
    img {
      width: 100%;
    }
  }
}
</style>
